import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";
import useUser from "@/users/useUser";
import stringifyParams from "@/utils/stringifyParams";

const useReadingLevelGet = (queryParams = {}, skip = false) => {
  const { data: user } = useUser();
  const userUniqueId = user?.unique_id;
  const params = { user_id: userUniqueId, ...queryParams };
  const resource = `${API_BASE_URL}/api/v3/reading-level/${stringifyParams(params)}`;

  return useRestQuery(resource, { skip });
};

export default useReadingLevelGet;
